import { Title } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MediaObserver } from '@angular/flex-layout';
import { MultilevelNodes, Configuration } from 'ng-material-multilevel-menu';

import { AuthenticationService, CredentialsService } from '@app/login';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { UserAttributionsEnum, UserType } from '@app/@core/constants/user-credentials.constants';
import {
  THIRD_PARTY_SAML_SEARCH,
  URL_CONTROL_PANEL_ACTION_AGENT,
  URL_CONTROL_PANEL_AGENT_STATISTICS,
  URL_CONTROL_PANEL_GENERAL_INVESTMENT,
  URL_CONTROL_PANEL_INVEST_DETAIL_OPERATION,
  URL_CONTROL_PANEL_INVEST_PRODUCT,
  URL_CONTROL_PANEL_OPERATION_DETAIL,
  URL_CONTROL_PANEL_OPERATION_VALIDATION,
  URL_REVOLVING_PURCHASE,
  URL_REVOLVING_QUERY,
  URL_REVOLVING_REFUND,
  URL_TARIFF_CI_CO,
  URL_TARIFF_DISCOUNT,
  URL_TARIFF_INTEREST,
  URL_TARIFF_IRREGULAR_QUOTAS,
  URL_TARIFF_LEASING,
  URL_TRAINING_DOCUMENTATION,
  URL_USERS_ADMIN_REPORT,
  URL_USERS_BRAND,
  URL_USERS_DIGITAL_SIGNATURE,
  URL_USERS_ECOMMERCE,
  URL_USERS_OTHER_PASSWORD,
  URL_USERS_OWN_PASSWORD,
  URL_USERS_PASSWORD_POLICY,
  URL_USERS_REGISTER_USER,
  URL_USERS_SEARCH,
  URL_USERS_SEARCH_OPERATIONS,
  URL_USERS_WHITELIST,
  URL_USER_PROFILES_CREATE_PROFILE,
  URL_USER_PROFILES_DELETE_PROFILE,
  URL_USER_PROFILES_EDIT_PROFILE,
  URL_USER_PROFILES_MANAGE_ATTRIBUTIONS,
  HELP,
  HOME,
  LOGIN,
  URL_REQUESTS_PANEL,
  URL_REQUESTS_CALCULATOR_AUTOS,
  URL_REQUESTS_CALCULATOR,
  URL_REQUESTS_REQUEST_AUTOS,
  URL_REQUESTS_REQUEST,
  URL_REQUESTS_REQUEST_MG_NO_SHOPPING,
  URL_REQUESTS_REQUEST_MG,
  URL_REQUESTS_REQUEST_BP,
  URL_REQUESTS_REQUEST_CG,
  URL_ACTIVITY_PANEL,
  URL_ACTIVITY_PAYMENTS,
  URL_ACTIVITY_MACRO,
  URL_TRAINING_PILLS,
  URL_TRAINING_TIPS,
  URL_ACTIVITY_MACRO_CURRENT_MONTH,
  URL_PAYMENTCERT_REGISTER,
  URL_PAYMENTCERT_HISTORY,
  URL_CONTROL_PANEL_PENALTY_DETAIL_OPERATION,
} from '@app/@core/constants/routes.constants';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent implements OnInit {
  config: Configuration;
  appitems: MultilevelNodes[];
  menuWithID: MultilevelNodes[] = null;

  constructor(
    private router: Router,
    private titleService: Title,
    private authenticationService: AuthenticationService,
    private credentialsService: CredentialsService,
    private media: MediaObserver,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.translateService.onLangChange.pipe(untilDestroyed(this)).subscribe((eventEmitted: LangChangeEvent) => {
      this.setMenuItems();
    });

    this.config = {
      highlightOnSelect: true,
      collapseOnSelect: true,
      paddingAtStart: true,
      useDividers: false,
      interfaceWithRoute: true,
      classname: 'app-sidemenu-tree',
    };
    this.setMenuItems();
    console.log('MENU ITEMS', this.appitems);

    this.addItems();
  }

  // Se añade el metodo addMenuItems, ya que si al menuItems le añades dos elemnentos con el mismo link no marca correctamente el elemento seleccionado
  addItems() {
    const itemConsumptionAutos: MultilevelNodes = {
      label: this.translateService.instant('sidenav.menu.requests.request'),
      link: this.credentialsService.isDivisionAutos() ? URL_REQUESTS_REQUEST_AUTOS : URL_REQUESTS_REQUEST,
      hidden:
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REDUCED_CAPTAIN_GS) ||
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REDUCED_CAPTAIN) ||
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ALTA_BP) ||
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CAPTAIN_BUY_MG) ||
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CAPTAIN_NO_BUY_MG) ||
        !(
          this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_NEW_REQUEST) &&
          (this.credentialsService.isDivisionAutos()
            ? this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_AUTOS)
            : this.authenticationService.permissionURL(URL_REQUESTS_REQUEST))
        ),
    };

    const itemRepsol: MultilevelNodes = {
      label: this.translateService.instant('sidenav.menu.requests.request-repsol'),
      link: URL_REQUESTS_REQUEST,
      hidden: !(
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REDUCED_CAPTAIN) &&
        this.authenticationService.permissionURL(URL_REQUESTS_REQUEST)
      ),
    };

    let position = 7;

    if (this.authenticationService.isRepsol()) {
      this.appitems[2].items.splice(position, 0, itemRepsol);
    } else if (this.credentialsService.isDivisionConsumption() || this.credentialsService.isDivisionAutos()) {
      position = 2;
      this.appitems[2].items.splice(position, 0, itemConsumptionAutos);
    }
  }
  setMenuItems() {
    this.appitems = [
      {
        label: this.translateService.instant('sidenav.menu.home'),
        link: HOME,
        faIcon: 'icon-ic_home_sab',
      },
      {
        label: this.translateService.instant('sidenav.menu.techAdmin'),
        link: '/tech-admin',
        faIcon: 'icon-ic_help',
        hidden: !this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_TECH_ADMIN),
      },
      {
        label: this.translateService.instant('sidenav.menu.requests'),
        faIcon: 'icon-ic_list_checked',
        hidden:
          this.isAdminServiceMarketing() ||
          this.credentialsService.credentials.userType === UserType.TECH_ADMIN ||
          (!(
            this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_LIST_LAST) &&
            this.authenticationService.permissionURL(URL_REQUESTS_PANEL)
          ) &&
            !(this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SIMULATION) &&
            this.credentialsService.isDivisionAutos()
              ? this.authenticationService.permissionURL(URL_REQUESTS_CALCULATOR_AUTOS)
              : this.authenticationService.permissionURL(URL_REQUESTS_CALCULATOR)) &&
            !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_NEW_REQUEST) &&
              (this.credentialsService.isDivisionAutos()
                ? this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_AUTOS)
                : this.authenticationService.permissionURL(URL_REQUESTS_REQUEST))
            ) &&
            !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CAPTAIN_NO_BUY_MG) &&
              this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_MG_NO_SHOPPING)
            ) &&
            !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CAPTAIN_BUY_MG) &&
              this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_MG)
            ) &&
            !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ALTA_BP) &&
              this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_BP)
            ) &&
            !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REDUCED_CAPTAIN_GS) &&
              this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_CG)
            ) &&
            !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REDUCED_CAPTAIN) &&
              this.authenticationService.permissionURL(URL_REQUESTS_REQUEST)
            )),
        //TODO: Add attributions request
        items: [
          {
            label: this.translateService.instant('sidenav.menu.requests.panel'),
            link: URL_REQUESTS_PANEL,
            hidden: !(
              // this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_LIST_ALL) &&
              (
                this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_LIST_LAST) &&
                this.authenticationService.permissionURL(URL_REQUESTS_PANEL)
              )
            ),
          },
          //TODO: Buscador de solicitudes?
          {
            label: this.translateService.instant('sidenav.menu.requests.calculator'),
            link: this.credentialsService.isDivisionAutos() ? URL_REQUESTS_CALCULATOR_AUTOS : URL_REQUESTS_CALCULATOR,
            hidden:
              !this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SIMULATION) &&
              (this.credentialsService.isDivisionAutos()
                ? !this.authenticationService.permissionURL(URL_REQUESTS_CALCULATOR_AUTOS)
                : !this.authenticationService.permissionURL(URL_REQUESTS_CALCULATOR)),
          },
          {
            label: this.translateService.instant('sidenav.menu.requests.request-mg-no-shopping'),
            link: URL_REQUESTS_REQUEST_MG_NO_SHOPPING,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CAPTAIN_NO_BUY_MG) &&
              this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_MG_NO_SHOPPING)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.requests.request-mg'),
            link: URL_REQUESTS_REQUEST_MG,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CAPTAIN_BUY_MG) &&
              this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_MG)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.requests.request-bp'),
            link: URL_REQUESTS_REQUEST_BP,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ALTA_BP) &&
              this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_BP)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.requests.cg'),
            link: URL_REQUESTS_REQUEST_CG,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REDUCED_CAPTAIN_GS) &&
              this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_CG)
            ),
          },
        ],
      },
      {
        label: this.translateService.instant('sidenav.menu.revolving'),
        faIcon: 'icon-ic_shop_list',
        hidden:
          this.isAdminServiceMarketing() ||
          !(
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REVOLVING_PURCHASES) &&
              this.authenticationService.permissionURL(URL_REVOLVING_PURCHASE)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REVOLVING_REFUNDS) &&
              this.authenticationService.permissionURL(URL_REVOLVING_REFUND)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REVOLVING_QUERIES) &&
              this.authenticationService.permissionURL(URL_REVOLVING_QUERY))
          ),
        items: [
          {
            label: this.translateService.instant('sidenav.menu.revolving.purchases'),
            link: URL_REVOLVING_PURCHASE,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REVOLVING_PURCHASES) &&
              this.authenticationService.permissionURL(URL_REVOLVING_PURCHASE)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.revolving.refunds'),
            link: URL_REVOLVING_REFUND,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REVOLVING_REFUNDS) &&
              this.authenticationService.permissionURL(URL_REVOLVING_REFUND)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.revolving.queries'),
            link: URL_REVOLVING_QUERY,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REVOLVING_QUERIES) &&
              this.authenticationService.permissionURL(URL_REVOLVING_QUERY)
            ),
          },
        ],
      },
      {
        label: this.translateService.instant('sidenav.menu.reports'),
        faIcon: 'icon-ic_document_alert',
        hidden:
          this.isAdminServiceMarketing() ||
          !(
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ACTIVITY_PANEL) &&
              this.authenticationService.permissionURL(URL_ACTIVITY_PANEL)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ACTIVITY_REPORT) &&
              this.authenticationService.permissionURL(URL_ACTIVITY_PAYMENTS)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ACTIVITY_MACRO) &&
              this.authenticationService.permissionURL(URL_ACTIVITY_MACRO)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ACTIVITY_MACRO) &&
              this.authenticationService.permissionURL(URL_ACTIVITY_MACRO_CURRENT_MONTH))
          ),
        items: [
          {
            label: this.translateService.instant('sidenav.menu.reports.panel'),
            link: URL_ACTIVITY_PANEL,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ACTIVITY_PANEL) &&
              this.authenticationService.permissionURL(URL_ACTIVITY_PANEL)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.reports.payments'),
            link: URL_ACTIVITY_PAYMENTS,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ACTIVITY_REPORT) &&
              this.authenticationService.permissionURL(URL_ACTIVITY_PAYMENTS)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.reports.detail'),
            link: URL_ACTIVITY_MACRO,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ACTIVITY_MACRO) &&
              this.authenticationService.permissionURL(URL_ACTIVITY_MACRO)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.reports.current-month'),
            link: URL_ACTIVITY_MACRO_CURRENT_MONTH,
            //TODO-Jed: Change the attribution when backend is finished
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ACTIVITY_MACRO) &&
              this.authenticationService.permissionURL(URL_ACTIVITY_MACRO_CURRENT_MONTH)
            ),
          },
        ],
      },
      {
        label: this.translateService.instant('sidenav.menu.paymentCertifications'),
        faIcon: 'icon-ic_payment-sheet',
        hidden: !this.authenticationService.isPaymentCertifications(),
        items: [
          {
            label: this.translateService.instant('sidenav.menu.certifiedPayment'),
            link: URL_PAYMENTCERT_HISTORY,
            hidden: !this.authenticationService.isPaymentCertifications(),
          },
          {
            label: this.translateService.instant('sidenav.menu.registerPapyments'),
            link: URL_PAYMENTCERT_REGISTER,
            hidden: !this.authenticationService.isPaymentCertifications(),
          },
        ],
      },
      {
        label: this.translateService.instant('sidenav.menu.control-panel'),
        faIcon: 'icon-ic_printer',
        hidden:
          this.isAdminServiceMarketing() ||
          !(
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_INVEST_DETAIL_OPS) &&
              this.authenticationService.permissionURL(URL_CONTROL_PANEL_INVEST_DETAIL_OPERATION)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_INVEST_PRODUCT) &&
              this.authenticationService.permissionURL(URL_CONTROL_PANEL_INVEST_PRODUCT)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_OPERATION_DETAIL) &&
              this.authenticationService.permissionURL(URL_CONTROL_PANEL_OPERATION_DETAIL)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_AGENT_STATISTICS) &&
              this.authenticationService.permissionURL(URL_CONTROL_PANEL_AGENT_STATISTICS)) ||
            (this.authenticationService.permissionAction(
              UserAttributionsEnum.ATTR_CONTROL_PANEL_OPERATION_VALIDATION
            ) &&
              this.authenticationService.permissionURL(URL_CONTROL_PANEL_OPERATION_VALIDATION)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_ACTION_PLAN) &&
              this.authenticationService.permissionURL(URL_CONTROL_PANEL_ACTION_AGENT)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_GENERAL_INVESTMENT) &&
              this.authenticationService.permissionURL(URL_CONTROL_PANEL_GENERAL_INVESTMENT))
          ),
        items: [
          {
            label: this.translateService.instant('sidenav.menu.controlPanel.investDetail'),
            link: URL_CONTROL_PANEL_INVEST_DETAIL_OPERATION,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_INVEST_DETAIL_OPS) &&
              this.authenticationService.permissionURL(URL_CONTROL_PANEL_INVEST_DETAIL_OPERATION)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.controlPanel.penalty.detail'),
            link: URL_CONTROL_PANEL_PENALTY_DETAIL_OPERATION,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_INVEST_DETAIL_OPS) &&
              this.authenticationService.permissionURL(URL_CONTROL_PANEL_INVEST_DETAIL_OPERATION)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.controlPanel.investProduct'),
            link: URL_CONTROL_PANEL_INVEST_PRODUCT,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_INVEST_PRODUCT) &&
              this.authenticationService.permissionURL(URL_CONTROL_PANEL_INVEST_PRODUCT)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.controlPanel.operationDetail'),
            link: URL_CONTROL_PANEL_OPERATION_DETAIL,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_OPERATION_DETAIL) &&
              this.authenticationService.permissionURL(URL_CONTROL_PANEL_OPERATION_DETAIL)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.controlPanel.agentStatistics'),
            link: URL_CONTROL_PANEL_AGENT_STATISTICS,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_AGENT_STATISTICS) &&
              this.authenticationService.permissionURL(URL_CONTROL_PANEL_AGENT_STATISTICS)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.controlPanel.actionAgent'),
            link: URL_CONTROL_PANEL_ACTION_AGENT,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_ACTION_PLAN) &&
              this.authenticationService.permissionURL(URL_CONTROL_PANEL_ACTION_AGENT)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.controlPanel.operationValidation'),
            link: URL_CONTROL_PANEL_OPERATION_VALIDATION,
            hidden: !(
              this.authenticationService.permissionAction(
                UserAttributionsEnum.ATTR_CONTROL_PANEL_OPERATION_VALIDATION
              ) && this.authenticationService.permissionURL(URL_CONTROL_PANEL_OPERATION_VALIDATION)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.controlPanel.generalOfInvestment'),
            link: URL_CONTROL_PANEL_GENERAL_INVESTMENT,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_GENERAL_INVESTMENT) &&
              this.authenticationService.permissionURL(URL_CONTROL_PANEL_GENERAL_INVESTMENT)
            ),
          },
        ],
      },
      {
        label: this.translateService.instant('sidenav.menu.tariffSheet'),
        faIcon: 'icon-ic_list_edit',
        hidden:
          this.isAdminServiceMarketing() ||
          !(
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_TARIFF_SHEET_DISCOUNT_COMMERCE) &&
              this.authenticationService.permissionURL(URL_TARIFF_DISCOUNT)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_TARIFF_SHEET_INTEREST_CLIENT) &&
              this.authenticationService.permissionURL(URL_TARIFF_INTEREST)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_TARIFF_SHEET_CI_CO_AUTO) &&
              this.authenticationService.permissionURL(URL_TARIFF_CI_CO)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_TARIFF_SHEET_LEASING_AUTO) &&
              this.authenticationService.permissionURL(URL_TARIFF_LEASING)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_TARIFF_SHEET_IRREGULAR_QUOTA) &&
              this.authenticationService.permissionURL(URL_TARIFF_IRREGULAR_QUOTAS))
          ),
        items: [
          {
            label: this.translateService.instant('sidenav.menu.tariffSheet.discount'),
            link: URL_TARIFF_DISCOUNT,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_TARIFF_SHEET_DISCOUNT_COMMERCE) &&
              this.authenticationService.permissionURL(URL_TARIFF_DISCOUNT)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.tariffSheet.interest'),
            link: URL_TARIFF_INTEREST,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_TARIFF_SHEET_INTEREST_CLIENT) &&
              this.authenticationService.permissionURL(URL_TARIFF_INTEREST)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.tariffSheet.ciCo'),
            link: URL_TARIFF_CI_CO,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_TARIFF_SHEET_CI_CO_AUTO) &&
              this.authenticationService.permissionURL(URL_TARIFF_CI_CO)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.tariffSheet.leasing'),
            link: URL_TARIFF_LEASING,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_TARIFF_SHEET_LEASING_AUTO) &&
              this.authenticationService.permissionURL(URL_TARIFF_LEASING)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.tariffSheet.irregularQuota'),
            link: URL_TARIFF_IRREGULAR_QUOTAS,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_TARIFF_SHEET_IRREGULAR_QUOTA) &&
              this.authenticationService.permissionURL(URL_TARIFF_IRREGULAR_QUOTAS)
            ),
          },
        ],
      },
      {
        label: this.translateService.instant('sidenav.menu.training'),
        faIcon: 'icon-ic_academy',
        hidden: this.isAdminServiceMarketing() || this.credentialsService.credentials.userType === UserType.TECH_ADMIN,
        items: [
          {
            label: this.translateService.instant('sidenav.menu.training.documentation'),
            link: URL_TRAINING_DOCUMENTATION,
          },
          // TODO: Add in phase 2
          {
            label: this.translateService.instant('sidenav.menu.training.pills'),
            link: URL_TRAINING_PILLS,
          },
          {
            label: this.translateService.instant('sidenav.menu.training.tips'),
            link: URL_TRAINING_TIPS,
          },
        ],
      },
      {
        label: this.translateService.instant('sidenav.menu.commercial'),
        faIcon: 'icon-ic_profile_stroke',
        hidden:
          this.isAdminServiceMarketing() ||
          !(
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SEARCH_OPERATION) &&
              this.authenticationService.permissionURL(URL_USERS_SEARCH_OPERATIONS)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_NEW_USERS) &&
              this.authenticationService.permissionURL(URL_USERS_REGISTER_USER)) ||
            ((this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_GET_USERS) || //TODO: Is it needed?
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SEARCH_USER)) &&
              this.authenticationService.permissionURL(URL_USERS_SEARCH))
          ),
        items: [
          {
            label: this.translateService.instant('sidenav.menu.users.new'),
            link: URL_USERS_REGISTER_USER,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_NEW_USERS) &&
              this.authenticationService.permissionURL(URL_USERS_REGISTER_USER)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.users.search'), //My users + Search users
            link: URL_USERS_SEARCH,
            hidden: !(
              (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_GET_USERS) ||
                this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SEARCH_USER)) &&
              this.authenticationService.permissionURL(URL_USERS_SEARCH)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.users.operationSearch'),
            link: URL_USERS_SEARCH_OPERATIONS,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SEARCH_OPERATION) &&
              this.authenticationService.permissionURL(URL_USERS_SEARCH_OPERATIONS)
            ),
          },
        ],
      },
      {
        label: this.translateService.instant('sidenav.menu.help'),
        link: HELP,
        icon: 'question_answers',
        hidden: this.isAdminServiceMarketing() || this.credentialsService.credentials.userType === UserType.TECH_ADMIN,
      },
      /* ADMIN MENU */
      {
        label: this.translateService.instant('sidenav.menu.profiles'),
        faIcon: 'icon-ic_profile_stroke',
        hidden:
          !this.isAdminServiceMarketing() ||
          !(
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CREATE_PROFILE) &&
              this.authenticationService.permissionURL(URL_USER_PROFILES_CREATE_PROFILE)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_UPDATE_PROFILE) &&
              this.authenticationService.permissionURL(URL_USER_PROFILES_EDIT_PROFILE)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_DELETE_PROFILE) &&
              this.authenticationService.permissionURL(URL_USER_PROFILES_DELETE_PROFILE)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_UPDATE_ATTRIBUTIONS) &&
              this.authenticationService.permissionURL(URL_USER_PROFILES_MANAGE_ATTRIBUTIONS))
          ),
        items: [
          {
            label: this.translateService.instant('sidenav.menu.create.profile'),
            link: URL_USER_PROFILES_CREATE_PROFILE,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CREATE_PROFILE) &&
              this.authenticationService.permissionURL(URL_USER_PROFILES_CREATE_PROFILE)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.edit.profile'),
            link: URL_USER_PROFILES_EDIT_PROFILE,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_UPDATE_PROFILE) &&
              this.authenticationService.permissionURL(URL_USER_PROFILES_EDIT_PROFILE)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.delete.profile'),
            link: URL_USER_PROFILES_DELETE_PROFILE,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_DELETE_PROFILE) &&
              this.authenticationService.permissionURL(URL_USER_PROFILES_DELETE_PROFILE)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.manage.attributions'),
            link: URL_USER_PROFILES_MANAGE_ATTRIBUTIONS,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_UPDATE_ATTRIBUTIONS) &&
              this.authenticationService.permissionURL(URL_USER_PROFILES_MANAGE_ATTRIBUTIONS)
            ),
          },
        ],
      },
      {
        label: this.translateService.instant('sidenav.menu.users'),
        faIcon: 'icon-ic_profile_stroke',
        hidden:
          !this.isAdminServiceMarketing() ||
          !(
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SEARCH_OPERATION) &&
              this.authenticationService.permissionURL(URL_USERS_SEARCH_OPERATIONS)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SEARCH_USER) &&
              this.authenticationService.permissionURL(URL_USERS_SEARCH)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_NEW_USERS) &&
              this.authenticationService.permissionURL(URL_USERS_REGISTER_USER)) ||
            // this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_NEW_USERS_WEB) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CHANGE_PASSWORD) &&
              this.authenticationService.permissionURL(URL_USERS_OTHER_PASSWORD)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CHANGE_OWN_PASSWORD) &&
              this.authenticationService.permissionURL(URL_USERS_OWN_PASSWORD)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ADMINISTRATOR_REPORT) &&
              this.authenticationService.permissionURL(URL_USERS_ADMIN_REPORT)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_DIGITAL_SIGNATURE_REPORT) &&
              this.authenticationService.permissionURL(URL_USERS_DIGITAL_SIGNATURE)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ECCOMERCE_REPORT) &&
              this.authenticationService.permissionURL(URL_USERS_ECOMMERCE)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_PASSWORD_POLICIES) &&
              this.authenticationService.permissionURL(URL_USERS_PASSWORD_POLICY)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_MAINTENANCE_BRAND) &&
              this.authenticationService.permissionURL(URL_USERS_BRAND)) ||
            (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_MAINTENANCE_WHITE) &&
              this.authenticationService.permissionURL(URL_USERS_WHITELIST))
          ),
        items: [
          {
            label: this.translateService.instant('sidenav.menu.users.operationSearch'),
            link: URL_USERS_SEARCH_OPERATIONS,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SEARCH_OPERATION) &&
              this.authenticationService.permissionURL(URL_USERS_SEARCH_OPERATIONS)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.users.new'),
            link: URL_USERS_REGISTER_USER,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_NEW_USERS) &&
              this.authenticationService.permissionURL(URL_USERS_REGISTER_USER)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.users.search'),
            link: URL_USERS_SEARCH,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SEARCH_USER) &&
              this.authenticationService.permissionURL(URL_USERS_SEARCH)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.users.password'),
            link: URL_USERS_OTHER_PASSWORD,
            hidden: !(
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CHANGE_PASSWORD) &&
              this.authenticationService.permissionURL(URL_USERS_OTHER_PASSWORD)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.users.ownPassword'),
            link: URL_USERS_OWN_PASSWORD,
            hidden: !(
              this.authenticationService.permissionURL(URL_USERS_OWN_PASSWORD) &&
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CHANGE_OWN_PASSWORD)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.users.adminReport'),
            link: URL_USERS_ADMIN_REPORT,
            hidden: !(
              this.authenticationService.permissionURL(URL_USERS_ADMIN_REPORT) &&
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ADMINISTRATOR_REPORT)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.users.digitalSignature'),
            link: URL_USERS_DIGITAL_SIGNATURE,
            hidden: !(
              this.authenticationService.permissionURL(URL_USERS_DIGITAL_SIGNATURE) &&
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_DIGITAL_SIGNATURE_REPORT)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.users.ecommerce'),
            link: URL_USERS_ECOMMERCE,
            hidden: !(
              this.authenticationService.permissionURL(URL_USERS_ECOMMERCE) &&
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ECCOMERCE_REPORT)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.users.passwordPolicy'),
            link: URL_USERS_PASSWORD_POLICY,
            hidden: !(
              this.authenticationService.permissionURL(URL_USERS_PASSWORD_POLICY) &&
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_PASSWORD_POLICIES)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.users.brand'),
            link: URL_USERS_BRAND,
            hidden: !(
              this.authenticationService.permissionURL(URL_USERS_BRAND) &&
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_MAINTENANCE_BRAND)
            ),
          },
          {
            label: this.translateService.instant('sidenav.menu.users.whitelist'),
            link: URL_USERS_WHITELIST,
            hidden: !(
              this.authenticationService.permissionURL(URL_USERS_WHITELIST) &&
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_MAINTENANCE_WHITE)
            ),
          },
        ],
      },
      {
        label: 'SAML Terceros',
        link: THIRD_PARTY_SAML_SEARCH,
        faIcon: 'icon-ic_sign',
        hidden: !this.isAdminServiceMarketing(),
      },
    ];
  }

  menuIsReady(menus: MultilevelNodes[]) {
    this.menuWithID = menus;
    this.authenticationService.sendMenuShell(menus);
  }

  logout() {
    this.authenticationService.logout().subscribe(() => this.router.navigate([LOGIN], { replaceUrl: true }));
  }

  selectedItem($event: any) {}

  get username(): string | null {
    const credentials = this.credentialsService.credentials;
    return credentials ? credentials.username : null;
  }

  get isDesktop(): boolean {
    return this.media.isActive('gt-md');
  }

  get title(): string {
    return this.titleService.getTitle();
  }

  private isAdminServiceMarketing() {
    return (
      this.credentialsService.credentials.userType === UserType.ADMIN ||
      this.credentialsService.credentials.userType === UserType.CENTER_SERVICE ||
      this.credentialsService.credentials.userType === UserType.MARKETING_DIRECT ||
      this.credentialsService.credentials.userType === UserType.TECH_ADMIN
    );
  }
}
